import React, { useEffect, useState } from 'react';
import KenSelectWrap from '../../../global_components/KenSelect';
import KenDateTimePicker from '../../../global_components/KenDateTimePicker';
import {
  // courseOptions,
  intakeOptions,
  courses,
  years,
  intakes,
} from './data/data';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import { Button, Grid, TextField, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import KenInputField from '../../../global_components/KenInputField';
import { useHistory } from 'react-router-dom';
import KenLoader from '../../../Components/KenLoader/index';
import KenAutoComplete from '../../../global_components/KenAutoComplete/index';
import {
  getAcademicFilter,
  postProgramBatchSpecialization,
} from '../../../Utils/apiServices';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    margin: '1rem 0',
    padding: theme.spacing(2),
    minHeight: '80vh',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    background: theme.palette.KenColors.kenWhite,

    '& .MuiTextField-root': {
      margin: '0px',
      width: '100%',
    }
  },
  heading: {
    fontSize: 18,
    fontWeight: 700,
    color: '#061938',
    margin: 5,
  },
  TextField: {
    width: '100% !important',
    margin: '0 !important',
    height: '1.1876em',
  },
}));
const defaultValues = {
  program: '',
  intake: '',
  course: '',
  startDate: '',
  endDate: '',
  year: '',
};
const Program = (props) => {
  const min = 1;
  const max = 10000;
  console.log('in program');
  const classes = useStyles();
  const [selectedDate, handleDateChange] = useState(new Date());
  const [formValues, setFormValues] = useState(defaultValues);
  const [value, setValue] = React.useState('Online');
  const [values, setValues] = React.useState('');
  const [name, setName] = React.useState('');
  const [courseOptions, setCourseOptions] = React.useState([]);
  const [campusOptions, setCampusOptions] = React.useState([]);
  const [campusData, setCampusData] = React.useState([]);
  const [selectedProgram, setSelectedProgram] = React.useState();
  const [termOption, setTermOption] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [termCampusList, setTermCampusList] = useState([
    { title: 'Term 1-8 - Mumbai', value: 'Term 1-8 - Mumbai' },
    { title: 'Term 1-4 - Singapore & Term 5-8 - Sydney', value: 'Term 1-4 - Singapore & Term 5-8 - Sydney'},
    { title: 'Term 1-3 - Singapore & Term 4-6 - Sydney & Term 7-8 - Mumbai', value: 'Term 1-3 - Singapore & Term 4-6 - Sydney & Term 7-8 - Mumbai'},
    { title: 'Term 1-8 - Singapore', value: 'Term 1-8 - Singapore' },
    { title: 'Term 1-4 - Mumbai & Term 5-8 - Sydney', value: 'Term 1-4 - Mumbai & Term 5-8 - Sydney'},
    { title: 'Term 1-3 - Singapore & Term 4-6 - Mumbai & Term 7-8 - Sydney', value: 'Term 1-3 - Singapore & Term 4-6 - Mumbai & Term 7-8 - Sydney'},
    { title: 'Term 1-8 - Sydney', value: 'Term 1-8 - Sydney' }
  ]);
  const handleChange = (event) => {
    setValue(event.target.value);
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'program') {
      let selectedVal = e.target.value;
      let val = termOption.find((str) => {
        return str.label == selectedVal;
      });
      setSelectedProgram(val);
    }
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };
  const dateFormatter = (date) => {
    let dArr = date.split('-');
    return dArr[2] + '/' + dArr[1] + '/' + dArr[0];
  };
  const handleFilters = () => {
    props.setFilters(formValues);
    props.setIsFiltered(true);
  };
  const history = useHistory();

  const handleCampusChange = (e, i) => {
    let key = { term: i, campusName: e.target.value };
    if (
      !campusData.includes((el) => {
        return el.campusName === e.target.value;
      })
    ) {
      setCampusData([...campusData, key]);
    } else {
      let data = [...campusData];
      let index = data.findIndex((el) => {
        return el.campusName === e.target.value;
      });
      data[index] = key;
      setCampusData([...data]);
    }
  };
  const termCampusOptions = termCampusList?.map((e) => {
    return { title: e.title, value: e.value };
  });
  React.useEffect(() => {
    setLoading(true);
    getAcademicFilter()
      .then((res) => {
        let courseOptions = [];
        let termOption = [];
        let campusOptions = [];
        Object.entries(res['Academic Program']).map(([item, keyVal]) => {
          courseOptions.push({ label: item, value: item });
          termOption.push({
            label: item,
            value: keyVal.noOfTerms != 'N/A' ? keyVal.noOfTerms : 1,
            alias: keyVal?.alias,
          });
        });
        Object.entries(res['Campus']).map(([item, keyVal]) => {
          campusOptions.push({ label: item, value: item });
        });
        setCourseOptions(courseOptions);
        setTermOption(termOption);
        setCampusOptions(campusOptions);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);

  const addBatch = () => {
    let payload = {
      Program: {
        academicProgramsName: '',
        levelOfAcademicProgram: '',
        duration: {
          year: '',
          months: '',
        },
        numberofTerms: '',

        termduration: '',
      },
      Batch: {
        academicProgramsName: formValues.program,
        batchName: selectedProgram?.alias,
        startDate: dateFormatter(formValues.startDate),
        endDate: dateFormatter(formValues.endDate),
        batchStrength: values,
        year: formValues.year,
        intake: formValues.intake,
        campus: campusData,
      },
      Specialization: {
        academicProgramsName: '',
        specializationName: '',
      },
    };
    setLoading(true);
    postProgramBatchSpecialization(payload)
      .then((res) => {
        console.log(res);
        if (res.success) {
          alert(res.message);
          setLoading(false);
          history.push({
            pathname: `/app/add-activity`,
            state: {
              batchName: res.batchName,
            },
          });
        }
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  const selectTermCampus = (e) => {
    let data =  e.target.textContent;
    setCampusData([...campusData, data ]);
  };
  const IntakeDiv = (props = 1) => {
    const count = Number(props);
    return [...Array(count)].map((x, i) => (
      <>
        <Grid item sm={6} xs={12}>
          <KenInputField
            label={`Term ${i + 1}`}
            value={i + 1}
            optionalLabel={false}
            disabled={true}
            // onChange={(item, e) => handleTermChange(item, e)}
            style={{ fontSize: 12 }}
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          <KenSelectWrap
            name="Campus"
            label="Campus"
            options={campusOptions}
            // value={selectedCampus}
            dropdownColor="#FFFFFF"
            onChange={(e) => handleCampusChange(e, i + 1)}
            required
          />
        </Grid>
      </>
    ));
  };
  return (
    <Grid container spacing={2} style={{ maxWidth: 600 }}>
      {loading && <KenLoader />}
      <Grid item xs={12} sm={6}>
        <KenSelectWrap
          name="program"
          label="Program"
          options={courseOptions}
          value={formValues.program}
          dropdownColor="#FFFFFF"
          onChange={(e) => handleInputChange(e)}
          required
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <KenInputField
          label="Program Name"
          required
          placeholder="Program Name"
          name="totalDay"
          // onChange={(e) => setName(e.target.value)}
          value={selectedProgram?.alias}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <KenDateTimePicker
          name="startDate"
          label={'Start date'}
          value={formValues.startDate}
          type="date"
          required={true}
          defaultValue={formValues.startDate}
          onChange={handleInputChange}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <KenDateTimePicker
          name="endDate"
          label="End date"
          value={formValues.endDate}
          type="date"
          required={true}
          defaultValue={formValues.endDate}
          onChange={handleInputChange}
        />
      </Grid>
      {/* <Grid item xs={12} sm={12}>
        <FormControl component="fieldset">
          <RadioGroup
            aria-label="gender"
            name="gender1"
            value={value}
            onChange={handleChange}
            style={{ display: 'block', alignItems: 'center' }}
          >
            <b style={{ marginRight: '80px' }}>Mode</b>
            <FormControlLabel
              value="online"
              control={<Radio />}
              label="Online"
              style={{ margin: 'auto' }}
            />
            <FormControlLabel
              value="offline"
              control={<Radio />}
              label="Offline"
            />
          </RadioGroup>
        </FormControl>
      </Grid> */}
      <Grid item xs={12} sm={6}>
        <KenInputField
          // name="name"
          label="Intake Strength"
          value={values}
          optionalLabel={false}
          onChange={(e) => {
            var value = parseInt(e.target.value, 10);
            if (value > max) value = max;
            if (value < min) value = min;
            setValues(value);
          }}
          style={{ fontSize: 12 }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <KenInputField
          // name="name"
          label="No of Term"
          value={selectedProgram?.value}
          optionalLabel={false}
          onChange={(e) => handleInputChange(e)}
          style={{ fontSize: 12 }}
        />
      </Grid>
      <Grid item sm={6} xs={12}>
        <KenSelectWrap
          name="year"
          label="Year"
          options={years}
          value={formValues.year}
          dropdownColor="#FFFFFF"
          onChange={(e) => handleInputChange(e)}
          required
        />
      </Grid>
      <Grid item sm={6} xs={12}>
        <KenSelectWrap
          name="intake"
          label="Intake"
          options={intakes}
          value={formValues.intake}
          dropdownColor="#FFFFFF"
          onChange={(e) => handleInputChange(e)}
          required
        />
      </Grid>
      <Grid item sm={12} xs={12}>
        <KenAutoComplete
          options={termCampusOptions}
          label="Choose campus format"
          variant="outlined"
          onChange={selectTermCampus}
          required
        />
      </Grid>
      {/* {IntakeDiv(selectedProgram?.value)} */}
      <Grid
        item
        xs={12}
        style={{ display: 'flex', justifyContent: 'flex-end' }}
      >
        <Button variant="outlined" onClick={handleFilters} style={{height: '37px', marginRight: '10px'}} >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={addBatch}
        >
          Submit
        </Button>
      </Grid>
    </Grid>
  );
};

export default Program;
